module.exports = __webpack_public_path__ + "img/recuperar.53aa263c.png";